//
//
//
//
//
//
//
//
//
//
//
//

  import {mapMutations} from 'vuex'

  export default {
    data(){
      return {
          count: 1,
      }
    },
    async beforeMount(){
    },
    mounted(){
    },
    components: {},
    computed: {},
    methods: {},
    watch: {}
  }




// WEBPACK FOOTER //
// ./src/components/cart/Count.vue